// extracted by mini-css-extract-plugin
export var active = "_ci-2";
export var recordingDot = "_ci-1";
export var recordingIndicator = "_ci-0";